import { RootState } from '@/store/types'
import {
  Deadline,
  DeadlinesState,
  DeadlineConditions,
  DeadlineExpiredUpdateParams,
  DeadlineType,
} from '@/store/deadlines/types'
import axios from 'axios'
import _ from 'lodash'
import { ActionTree } from 'vuex'
import { getPagerFromApiResponse } from '@/store/utils'
import moment, { Moment } from 'moment'

const toState = (deadline: any, getters: any): Deadline => {
  return {
    id: deadline.id,
    expired: moment(deadline.expired, 'YYYYMMDDhhmmss'),
    isLate: deadline.isLate,
    isSend: deadline.isSend,
    comment: deadline.comment,
    type: deadline.type,
    isWaitingApproved: deadline.isWaitingApproved,
    lesson: {
      id: deadline.lesson.id,
      datetime: moment(`${deadline.lesson.date}${deadline.lesson.startTime}`, 'YYYYMMDDhhmm'),
      dayofweek: deadline.lesson.dayOfWeek,
      period: deadline.lesson.period,
      level: getters.findLevelByCode(deadline.lesson.levelCode),
      comment: deadline.lesson.comment,
      section: {
        name: deadline.lesson.sectionName,
      },
      unit: deadline.lesson.unit,
      fiscalyear: deadline.lesson.fiscalYear,
    },
    tutor: {
      tutorId: deadline.tutor.tutorId,
      name: deadline.tutor.name,
    },
    students: deadline.students,
  }
}

const actions: ActionTree<DeadlinesState, RootState> = {
  /* デッドライン一覧取得 */
  fetchDeadlines: async (
    { commit, getters, dispatch },
    { page, conditions, index }: {
      conditions?: DeadlineConditions, page: number, index: number|undefined
    },
  ) => {
    await dispatch('fetchMasterLevels')
    const { headers, data } = await axios.get('/deadlines', {
      params: {
        ..._.pickBy({
          lessonTutor: conditions?.tutor,
          deadlineInTime: conditions?.deadlineInTimes?.join(','),
          deadlineSend: conditions?.deadlineSends?.join(','),
          deadlineFrom: conditions?.deadlineFrom?.format('YYYYMMDDhhmmss'),
          deadlineTo: conditions?.deadlineTo?.format('YYYYMMDDhhmmss'),
          lessonDateFrom: conditions?.lessonDateFrom?.format('YYYYMMDD'),
          lessonDateTo: conditions?.lessonDateTo?.format('YYYYMMDD'),
          lessonLevelCode: conditions?.levels?.map(({ code }) => code).join(','),
          lessonPeriod: conditions?.periods?.join(','),
          type: conditions?.types?.join(',') || `${DeadlineType.classRecord},${DeadlineType.frs}`,
          id: conditions?.ids?.join(','),
          universityCode: conditions?.university?.code,
        }),
        page,
      },
    })

    const deadlines = _.map(data, (d) => toState(d, getters))

    commit('fetchedDeadlines', {
      pager: getPagerFromApiResponse(page, headers),
      deadlines,
    })

    if (index !== undefined) {
      commit('fetchedDeadlinesOfEach', {
        pager: getPagerFromApiResponse(page, headers),
        deadlines,
        index,
      })
    }
  },

  getDeadline: async (
    { commit, getters, dispatch },
    { id } : { id: string },
  ) => {
    await dispatch('fetchMasterLevels')
    const { data } = await axios.get(`/deadlines/${id}`)
    commit('gotDeadline', toState(data, getters))
  },

  updateDeadlinesExpired: async (
    context,
    params: DeadlineExpiredUpdateParams,
  ) => {
    await axios.put('/deadlines/bulkUpdate', {
      ids: params.ids,
      datetime: params.expired.format('YYYYMMDDHHmmss'),
      comment: params.comment,
    })
  },
}

export default actions
